import { FilterList, KeyboardArrowDown } from '@mui/icons-material';
import BuyerPoolLoader from 'components/Loading/BuyerPoolLoader';
import Filters from 'components/client-pool/Filters';
import NewRequestResults from 'components/client-pool/NewRequestResults';
import NoRequest from 'components/client-pool/NoRequest';
import PropertyCard from 'components/client-pool/PropertyCard';
import RequestDetails from 'components/client-pool/RequestDetails';
import RequestPostedModal from 'components/client-pool/RequestPostedModal';
import SavedFilters from 'components/client-pool/SavedFilters';
import SavedSearchFilter from 'components/client-pool/SavedSearchFilter';
import SelectedFilters from 'components/client-pool/SelectedFilters';
import { CityFilter, CountryFilter } from 'components/Filter';
import StateFilter from 'components/Filter/StateFilter';
import { PropertyPagination } from 'components/Pagination';
import { useGetPropertyRequests, useSavedPropertyRequests } from 'hooks/usePropertyRequests';
import { useState } from 'react';
import useAddRequestStore from 'store/addRequestStore';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
import useUserStore from 'store/useUserStore';
import { PropertyLead } from 'types/PropertyLead';
import NoItems from './NoItems';
import NeighborhoodFilter from 'components/Filter/NeighborhoodFilter';
import BudgetDropdown from 'components/client-pool/BudgetDropdown';

const mockPropertyRequests: PropertyLead[] = [
    {
        id: 'mock1',
        userId: 'user1',
        title: 'Luxury Villa in Dubai Marina',
        description: 'Looking for a modern luxury villa with high-end finishes and amenities',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Dubai Marina'],
        definedArea: 'Dubai Marina',
        propertyType: 'Villa',
        minConstructionArea: 300,
        maxConstructionArea: 500,
        minPlotArea: 400,
        maxPlotArea: 800,
        minBedrooms: 4,
        maxBedrooms: 6,
        minBathrooms: 4,
        maxBathrooms: 6,
        minBudget: 5000000,
        maxBudget: 8000000,
        urgency: 'High',
        commission: 2,
        amenities: 'Pool,Gym,Parking',
        furnishing: 'Unfurnished',
        otherSpecificRequirements: 'Sea view, private garden',
        isArchived: false,
        status: 'Active',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '1',
                propertyLeadId: '1',
                name: 'John Doe',
                email: 'john.doe@example.com',
                phone: '+971 50 123 4567',
                website: 'https://example.com',
                facebook: 'https://facebook.com/johndoe',
                instagram: 'https://instagram.com/johndoe',
                linkedin: 'https://linkedin.com/in/johndoe',
                twitter: 'https://twitter.com/johndoe',
                contactTime: '9:00 AM - 6:00 PM',
            },
        ],
        cities: [
            {
                id: '1',
                propertyLeadId: '1',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '1',
                propertyLeadId: '1',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '1',
                propertyLeadId: '1',
                neighborhood: 'Dubai Marina',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'High-end investor',
    },
    {
        id: 'mock2',
        userId: 'user2',
        title: 'Modern Apartment in Downtown',
        description: 'Seeking a contemporary apartment with city views',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Downtown Dubai'],
        definedArea: 'Downtown Dubai',
        propertyType: 'Apartment',
        minConstructionArea: 100,
        maxConstructionArea: 200,
        minPlotArea: 0,
        maxPlotArea: 0,
        minBedrooms: 2,
        maxBedrooms: 3,
        minBathrooms: 2,
        maxBathrooms: 3,
        minBudget: 2000000,
        maxBudget: 3000000,
        urgency: 'Medium',
        commission: 2,
        amenities: 'Gym,Parking',
        furnishing: 'Semi-furnished',
        otherSpecificRequirements: 'City view, balcony',
        isArchived: false,
        status: 'Pending',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '2',
                propertyLeadId: '2',
                name: 'Jane Smith',
                email: 'jane.smith@example.com',
                phone: '+971 50 987 6543',
                website: 'https://example.com',
                facebook: 'https://facebook.com/janesmith',
                instagram: 'https://instagram.com/janesmith',
                linkedin: 'https://linkedin.com/in/janesmith',
                twitter: 'https://twitter.com/janesmith',
                contactTime: '10:00 AM - 7:00 PM',
            },
        ],
        cities: [
            {
                id: '2',
                propertyLeadId: '2',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '2',
                propertyLeadId: '2',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '2',
                propertyLeadId: '2',
                neighborhood: 'Downtown Dubai',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'Young professional',
    },
    {
        id: 'mock3',
        userId: 'user3',
        title: 'Beachfront Penthouse',
        description: 'Looking for a luxury penthouse with direct beach access',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Palm Jumeirah'],
        definedArea: 'Palm Jumeirah',
        propertyType: 'Penthouse',
        minConstructionArea: 400,
        maxConstructionArea: 600,
        minPlotArea: 0,
        maxPlotArea: 0,
        minBedrooms: 3,
        maxBedrooms: 4,
        minBathrooms: 3,
        maxBathrooms: 4,
        minBudget: 8000000,
        maxBudget: 12000000,
        urgency: 'High',
        commission: 2,
        amenities: 'Pool,Gym,Parking,Beach Access',
        furnishing: 'Fully furnished',
        otherSpecificRequirements: 'Private beach access, panoramic views',
        isArchived: false,
        status: 'Active',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '3',
                propertyLeadId: '3',
                name: 'Mike Johnson',
                email: 'mike.johnson@example.com',
                phone: '+971 50 456 7890',
                website: 'https://example.com',
                facebook: 'https://facebook.com/mikejohnson',
                instagram: 'https://instagram.com/mikejohnson',
                linkedin: 'https://linkedin.com/in/mikejohnson',
                twitter: 'https://twitter.com/mikejohnson',
                contactTime: '9:00 AM - 6:00 PM',
            },
        ],
        cities: [
            {
                id: '3',
                propertyLeadId: '3',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '3',
                propertyLeadId: '3',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '3',
                propertyLeadId: '3',
                neighborhood: 'Palm Jumeirah',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'Luxury investor',
    },
    {
        id: 'mock4',
        userId: 'user4',
        title: 'Waterfront Apartment',
        description: 'Seeking a modern apartment with stunning water views',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Dubai Marina'],
        definedArea: 'Dubai Marina',
        propertyType: 'Apartment',
        minConstructionArea: 150,
        maxConstructionArea: 250,
        minPlotArea: 0,
        maxPlotArea: 0,
        minBedrooms: 2,
        maxBedrooms: 3,
        minBathrooms: 2,
        maxBathrooms: 3,
        minBudget: 3000000,
        maxBudget: 4500000,
        urgency: 'Medium',
        commission: 2,
        amenities: 'Pool,Gym,Parking,Marina Access',
        furnishing: 'Semi-furnished',
        otherSpecificRequirements: 'Marina view, private balcony',
        isArchived: false,
        status: 'Active',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '4',
                propertyLeadId: '4',
                name: 'Sarah Wilson',
                email: 'sarah.wilson@example.com',
                phone: '+971 50 789 1234',
                website: 'https://example.com',
                facebook: 'https://facebook.com/sarahwilson',
                instagram: 'https://instagram.com/sarahwilson',
                linkedin: 'https://linkedin.com/in/sarahwilson',
                twitter: 'https://twitter.com/sarahwilson',
                contactTime: '9:00 AM - 6:00 PM',
            },
        ],
        cities: [
            {
                id: '4',
                propertyLeadId: '4',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '4',
                propertyLeadId: '4',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '4',
                propertyLeadId: '4',
                neighborhood: 'Dubai Marina',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'Young professional',
    },
    {
        id: 'mock5',
        userId: 'user5',
        title: 'Golf Course Villa',
        description: 'Looking for a luxury villa overlooking the golf course',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Emirates Hills'],
        definedArea: 'Emirates Hills',
        propertyType: 'Villa',
        minConstructionArea: 400,
        maxConstructionArea: 600,
        minPlotArea: 600,
        maxPlotArea: 1000,
        minBedrooms: 4,
        maxBedrooms: 5,
        minBathrooms: 4,
        maxBathrooms: 5,
        minBudget: 7000000,
        maxBudget: 10000000,
        urgency: 'High',
        commission: 2,
        amenities: 'Pool,Gym,Parking,Golf Course Access',
        furnishing: 'Unfurnished',
        otherSpecificRequirements: 'Golf course view, private garden',
        isArchived: false,
        status: 'Active',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '5',
                propertyLeadId: '5',
                name: 'David Brown',
                email: 'david.brown@example.com',
                phone: '+971 50 456 7890',
                website: 'https://example.com',
                facebook: 'https://facebook.com/davidbrown',
                instagram: 'https://instagram.com/davidbrown',
                linkedin: 'https://linkedin.com/in/davidbrown',
                twitter: 'https://twitter.com/davidbrown',
                contactTime: '10:00 AM - 7:00 PM',
            },
        ],
        cities: [
            {
                id: '5',
                propertyLeadId: '5',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '5',
                propertyLeadId: '5',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '5',
                propertyLeadId: '5',
                neighborhood: 'Emirates Hills',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'High-end investor',
    },
    {
        id: 'mock6',
        userId: 'user6',
        title: 'Skyline Penthouse',
        description: 'Seeking a luxury penthouse with panoramic city views',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Downtown Dubai'],
        definedArea: 'Downtown Dubai',
        propertyType: 'Penthouse',
        minConstructionArea: 500,
        maxConstructionArea: 700,
        minPlotArea: 0,
        maxPlotArea: 0,
        minBedrooms: 3,
        maxBedrooms: 4,
        minBathrooms: 3,
        maxBathrooms: 4,
        minBudget: 9000000,
        maxBudget: 13000000,
        urgency: 'High',
        commission: 2,
        amenities: 'Pool,Gym,Parking,Private Elevator',
        furnishing: 'Fully furnished',
        otherSpecificRequirements: 'Burj Khalifa view, private terrace',
        isArchived: false,
        status: 'Active',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '6',
                propertyLeadId: '6',
                name: 'Emma Davis',
                email: 'emma.davis@example.com',
                phone: '+971 50 123 4567',
                website: 'https://example.com',
                facebook: 'https://facebook.com/emmadavis',
                instagram: 'https://instagram.com/emmadavis',
                linkedin: 'https://linkedin.com/in/emmadavis',
                twitter: 'https://twitter.com/emmadavis',
                contactTime: '9:00 AM - 6:00 PM',
            },
        ],
        cities: [
            {
                id: '6',
                propertyLeadId: '6',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '6',
                propertyLeadId: '6',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '6',
                propertyLeadId: '6',
                neighborhood: 'Downtown Dubai',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'Luxury investor',
    },
];

export default function NewRequests({ setCurrentTab }: { setCurrentTab: (tab: string) => void }) {
    const [visible, setVisible] = useState(false);
    const [savedSearchFilterVisible, setSavedSearchFilterVisible] = useState(false);
    const { getUserPlan } = useUserStore();
    const userPlan = getUserPlan();

    const { requestPostedModalVisible, setRequestPostedModalVisible, propertyRequestDetailModalVisible } = useAddRequestStore();
    const { propertyRequestQueryFilter, setPropertyRequestQueryFilter, page, setPage, region, setRegion } = usePropertyRequestsStore();

    const { data, isLoading } = useGetPropertyRequests({ ...propertyRequestQueryFilter, page: page + 1 });

    useSavedPropertyRequests();

    if (isLoading) return <BuyerPoolLoader />;

    return (
        <div className="pt-4 pb-10">
            {userPlan.title !== 'Free' && (
                <div className="pt-4 rounded-md border border-my-gray/80">
                    {/* City, Neighborhood and Budget Filters */}
                    <div className="flex w-full gap-4 pb-4 px-4 md:flex-row flex-col">
                        <div className="h-12 md:h-12 md:flex-1">
                            <CityFilter
                                selectedCities={propertyRequestQueryFilter.propertyCity}
                                onChanged={(city) => setPropertyRequestQueryFilter({ ...propertyRequestQueryFilter, propertyCity: city })}
                                region={region}
                                selectedStates={propertyRequestQueryFilter.propertyState}
                                placeholder="Area"
                            />
                        </div>
                        <div className="h-12 md:h-12 md:flex-1">
                            <NeighborhoodFilter
                                selectedNeighborhoods={propertyRequestQueryFilter.propertyNeighborhood}
                                onChanged={(neighborhood: string[]) =>
                                    setPropertyRequestQueryFilter({ ...propertyRequestQueryFilter, propertyNeighborhood: neighborhood })
                                }
                                region={region}
                                selectedStates={propertyRequestQueryFilter.propertyState}
                                selectedCities={propertyRequestQueryFilter.propertyCity}
                                placeholder="Neighborhood"
                            />
                        </div>
                        <div className="h-12 md:h-12 md:flex-1">
                            <BudgetDropdown
                                value={[propertyRequestQueryFilter.minBudget || 0, propertyRequestQueryFilter.maxBudget || 0]}
                                onChange={(range: [number, number]) => {
                                    const [minBudget, maxBudget] = range;
                                    setPropertyRequestQueryFilter({
                                        ...propertyRequestQueryFilter,
                                        minBudget,
                                        maxBudget,
                                    });
                                }}
                            />
                        </div>
                    </div>
                    {/* {Selected Filters} */}
                    <div className="border border-my-gray/40" />
                    <SelectedFilters setSavedSearchFilterVisible={setSavedSearchFilterVisible} />

                    {/* Filters */}
                    <div className="bg-my-gray/10 rounded-md py-3 border-t border-my-gray/80 mx-auto cursor-pointer">
                        <p className="text-base font-semibold text-center" onClick={() => setVisible(true)}>
                            <FilterList className="text-my-blue mr-1" />
                            Filters
                            <KeyboardArrowDown className="text-gray-500 ml-1" />
                        </p>
                    </div>
                </div>
            )}
            {/* Saved Filters */}
            {userPlan.title !== 'Free' && <SavedFilters />}

            {/* {Results} */}
            <NewRequestResults />

            <div className="bg-white/70 border border-my-gray/80 rounded-lg px-4 pb-2">
                {data?.data?.data?.leads.length === 0 ? (
                    <NoRequest />
                ) : (
                    <div className="grid grid-cols-1 place-items-center lg:grid-cols-3 gap-4 py-4 mt-2 rounded-md bg-white">
                        {data?.data?.data?.leads.map((lead: PropertyLead) => <PropertyCard key={lead.id} lead={lead} />)}
                    </div>
                )}

                {/* Mocked Property Cards for Free Plan Users */}
                {userPlan.title === 'Free' && (
                    <div className="relative">
                        <div className="grid grid-cols-1 place-items-center lg:grid-cols-3 gap-4 py-4 mt-2 rounded-md bg-white">
                            {mockPropertyRequests.map((lead: PropertyLead) => (
                                <PropertyCard key={lead.id} lead={lead} />
                            ))}
                        </div>
                        <div className="absolute inset-0 z-10 bg-white/80 backdrop-blur-sm" />
                        <div className="absolute inset-0 z-20 flex items-center justify-center">
                            <NoItems title="Upgrade Your Plan" description="Upgrade your plan to access more buyer requests and advanced features!" />
                        </div>
                    </div>
                )}

                {/* Pagination */}
                {data?.data?.data?.total > 1 && userPlan.title !== 'Free' && (
                    <div className="mx-auto w-fit py-4">
                        <PropertyPagination
                            totalPageCount={Math.ceil(data?.data?.data?.total / 12)}
                            currentPage={page}
                            handlePageChange={(page: number) => setPage(page)}
                        />
                    </div>
                )}
            </div>

            {/* Modals */}
            <Filters visible={visible} onClose={() => setVisible(false)} />
            <SavedSearchFilter visible={savedSearchFilterVisible} onClose={() => setSavedSearchFilterVisible(false)} />
            <RequestDetails visible={propertyRequestDetailModalVisible} />
            <RequestPostedModal visible={requestPostedModalVisible} onClose={() => setRequestPostedModalVisible(false)} setCurrentTab={setCurrentTab} />
        </div>
    );
}
